import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import MarketerInquiryList from '../../components/admin/marketer/MarketerInquiryList';
import MarketerNoLoginAdCallList from '../../components/admin/marketer/MarketerNoLoginAdCallList';
import PointRefundSummary from '../../components/admin/marketer/PointRefundSummary';
import AdvertiserInfoSummary from '../../components/admin/advertiser/AdvertiserInfoSummary';
import '../../styles/pages/AdminPages.css';

function AdvertiserPage() {
  const navigate = useNavigate();

  return (
    <AdminLayout title="광고주 관리">
      <div className="admin-page__dashboard">
        {/* 로그인 후 문의내역(광고주) */}
        <div className="admin-page__section">
          <MarketerInquiryList interactive={false} />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/advertiser/inquiry-check')}>
              관리
            </button>
          </div>
        </div>

        {/* 비로그인 광고대행 문의 */}
        <div className="admin-page__section">
          <MarketerNoLoginAdCallList interactive={false} />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/advertiser/adcall-check')}>
              관리
            </button>
          </div>
        </div>

        {/* 광고주 환불 요청 */}
        <div className="admin-page__section">
          <PointRefundSummary interactive={false} />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/advertiser/refund')}>
              관리
            </button>
          </div>
        </div>

        {/* 광고주 정보 관리 */}
        <div className="admin-page__section">
          <AdvertiserInfoSummary />
          <div className="admin-page__section-action">
            <button className="admin-page__action-button" type="button" onClick={() => navigate('/admin/advertiser/info-management')}>
              관리
            </button>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdvertiserPage;
